// these sizes are arbitrary and you can set them to whatever you wish

function _mediaCss(size) {

  return (args) => `
    @media (max-width: ${size}px) {
      ${args}
    }
  `;
}

const sizes = {
  xs: 769,
  md: 992,
  lg: 1200,
  xl: 1600,
};

export const media = {
  xs: _mediaCss(sizes.xs),
  md: _mediaCss(sizes.md),
  lg: _mediaCss(sizes.lg),
  xl: _mediaCss(sizes.xl),
  xxl: _mediaCss(sizes.xxl)
};
